module.exports = __webpack_public_path__ + "static/media/Ebit-Nielsen-Logo.0c6d9711.0c6d9711.png";